import { clsx } from 'clsx';
import { trimEnd } from 'lodash';
import { twMerge } from 'tailwind-merge';
import settings from '../settings';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
const serializeQuery = (obj) => {
    const recursive = (data) => {
        return Object.entries(data).reduce((acc, [key, val]) => {
            if (Array.isArray(val) && val.length) {
                acc.push(val.map((item) => `${key}[]=${item}`).join('&'));
            }
            else if (typeof val === 'object' && val !== null) {
                acc = [...acc, ...recursive(val)];
            }
            else if (val !== '' && val !== undefined && val !== null) {
                acc.push(`${key}=${typeof val === 'boolean' ? val : encodeURIComponent(val)}`);
            }
            return acc;
        }, []);
    };
    const listParams = recursive(obj);
    return listParams.join('&').replace('&&', '&');
};
export const route = (to) => trimEnd(`/${settings.routePrefix}/${to}`.replace(/\/+/g, '/'), '/') || '/';
export default serializeQuery;
